import React, {forwardRef, useEffect, useState} from 'react';
import {mostrarRutas} from "../../redux/reducers/rutasReducers";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Paper,
    Theme,
    Typography,
    useMediaQuery,
} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import LoadingProgress from "../../components/LoadingProgress";
import Strings from "../../assets/strings"
import {IRutaOrdenar} from "../../redux/types/IRuta";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {getClientes, ordenarClienteRuta} from "../../services";
import {DragIndicator} from "@mui/icons-material";
import TopBarDialog from "../../components/topBar/TopBarDialog";

import {DndContext, DragEndEvent, DragOverlay} from '@dnd-kit/core';
import {arrayMove, SortableContext, useSortable} from '@dnd-kit/sortable';
import {restrictToParentElement} from '@dnd-kit/modifiers';

import {CSS} from '@dnd-kit/utilities';
import SearchClienteDialog from "../../components/SearchClienteDialog";
import Notifications from "react-notification-system-redux";
import {hasPermissionTo, PERSMISOS} from "../../helpers";


export default function OrdenarClientes() {
    const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));

    const navigate = useNavigate();
    let dispatch = useAppDispatch();
    const { status } = useAppSelector(state => state.rutas);
    const [loading, setLoading] = useState(false);

    const goBack = () => navigate(-1);
    const {state:urlState={}} = useLocation();

    const [clientes, setClientes] = useState<{id:number, nombre:string }[]>([]);
    const [activeId, setActiveId] = useState(null);


    useEffect(() => {
        if(urlState?.ordenarPorRuta?.id){
            getClientes({rutaId: urlState.ordenarPorRuta.id}, true).then(({data})=>{
                setClientes(data)
            })
        }else{
            setClientes([])
        }
    }, [setClientes, urlState?.ordenarPorRuta]);

    const handleSubmit =  ()  => {
        let list = clientes.map((c,i)=>({key: c.id, value: i + 1}))

        let obj: IRutaOrdenar = {
            id: urlState?.ordenarPorRuta?.id,
            clientes: list
        }

        setLoading(true)
        ordenarClienteRuta(obj).then(res=>{
            dispatch(mostrarRutas({}))
        }).finally(()=>setLoading(false))
    };

    function handleDragEnd(e: DragEndEvent) {
        const { over, active } = e;

        if (active.id !== over?.id) {
            setClientes((items) => {
                const oldIndex = items.findIndex(f => f.id === active.id);
                const newIndex = items.findIndex(f => f.id === over?.id);
                return arrayMove(items, oldIndex, newIndex);
            });
        }
        setActiveId(null)
    }
    function handleDragStart(event: DragEndEvent) {
        const {active} = event;
        // @ts-ignore
        setActiveId(active.id);
    }


    return (
        <>
            <Dialog open={Boolean(urlState && urlState.hasOwnProperty("ordenarPorRuta"))} onClose={goBack} fullScreen={smVewport} maxWidth={"xs"} fullWidth={true}>
                <TopBarDialog title={urlState?.ordenarPorRuta?.descripcion} onClose={goBack}/>

                {hasPermissionTo(PERSMISOS.rutasOrdenar) &&
                    <Box
                        sx={{
                            width: "calc(100% - 32px)",
                            background: "#f6f6f6",
                            mx:2,
                            mt:1
                        }}
                    >
                        <SearchClienteDialog
                            buttonLabel={"Agregar Cliente"}
                            required
                            value={undefined}
                            cliente={""}
                            onChange={(cli)=>{
                                let existe = clientes.some(c=>c.id === cli.id);
                                if(!existe) {
                                    setClientes(prevState => [...prevState, {id: cli.id!, nombre: cli.nombres+" "+cli.apellidos}])
                                }else{
                                    dispatch(Notifications.warning({title: `Este cliente ya esta agregado`, autoDismiss: 5}))
                                }
                            }}
                        />
                    </Box>
                }



                    <DialogContent sx={{px:2, py:1}}>
                        {(status === "loading") && <LoadingProgress />}
                        <DndContext
                            onDragEnd={handleDragEnd}
                            onDragStart={handleDragStart}
                            // modifiers={[restrictToVerticalAxis]}
                        >
                            <SortableContext items={clientes.map(c=>c.id!)} >
                                {clientes.map(c => <SortableItem key={c.id} cliente={c} />)}
                            </SortableContext>
                            <DragOverlay
                                modifiers={[restrictToParentElement]}
                            >
                                {/*// @ts-ignore*/}
                                {activeId ? <Item cliente={clientes.find(c=>c.id === activeId)} /> : null}
                            </DragOverlay>
                        </DndContext>

                    </DialogContent>
                    {hasPermissionTo(PERSMISOS.rutasOrdenar) &&
                        <DialogActions>
                            {/*<Button onClick={handleSubmit} color="primary" disabled={status === "loading" || !!loading}>*/}
                            {/*    {Strings.guardar}*/}
                            {/*</Button>*/}

                            <Button type={"button"} color="warning" variant={"text"} onClick={goBack}>
                                {Strings.cancelar}
                            </Button>
                            <Button onClick={handleSubmit} color="primary" disabled={status === "loading" || !!loading} variant={"outlined"}
                            >
                                Guardar
                            </Button>
                        </DialogActions>
                    }
            </Dialog>
        </>
    );

}



function SortableItem({cliente}:{cliente:{id:number, nombre: string}}) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({
        id: cliente.id!,
        disabled: !hasPermissionTo(PERSMISOS.rutasOrdenar)
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <Paper
            variant={"outlined"}
            sx={{
                display:"flex",
                justifyContent:"space-between",
                py:1.5,
                px:1,
                my:0.5,
                cursor:"grab",
                "&:active":{
                    cursor:"grabbing",
                    opacity: 0.5

                }
            }}
            ref={setNodeRef}
            style={style} {...attributes} {...listeners}
        >

            <Typography flexGrow={1} px={1}>{cliente.nombre}</Typography>
            <DragIndicator sx={{color:"#b9b9b9"}}/>
        </Paper>
    )
}


// @ts-ignore
export const Item = forwardRef(({cliente, ...props}, ref) => {
    return (
        // @ts-ignore
        // <div {...props} ref={ref}>{id}</div>
        <Paper
            ref={ref}
            variant={"outlined"}
            sx={{
                display:"flex",
                justifyContent:"space-between",
                py:1.5,
                px:1,
                my:0.5,
                cursor:"grab",
                boxShadow: "0px 4px 7px 0px #bababa",
                transform:"scale3D(1.01)"
            }}
        >

            <Typography flexGrow={1} px={1}>{cliente.nombre}</Typography>
            <DragIndicator sx={{color:"#939393"}}/>
        </Paper>
    )
});
